const getRawErrorMessage = (error) => (
  error?.data?.message ||
  error?.data?.originalError?.message ||
  error?.cause?.message ||
  error?.error?.message ||
  error?.message ||
  'Unknown contract execution error.'
);

const normalizeRevertReason = (message) => {
  if (!message?.toLowerCase().includes('execution reverted')) {
    return '';
  }

  return message.replace(/^.*execution reverted:\s*/i, '').trim();
};

export const getContractExecutionErrorMessage = (error) => {
  const rawMessage = getRawErrorMessage(error).trim();
  const normalizedMessage = rawMessage.toLowerCase();

  if (
    normalizedMessage.includes('user denied') ||
    normalizedMessage.includes('user rejected') ||
    normalizedMessage.includes('rejected the request') ||
    normalizedMessage.includes('transaction was rejected')
  ) {
    return 'The transaction was cancelled in the wallet.';
  }

  if (
    normalizedMessage.includes('insufficient funds') ||
    normalizedMessage.includes('not enough funds')
  ) {
    return 'The connected wallet does not have enough balance to complete this transaction.';
  }

  if (
    normalizedMessage.includes('invalid address') ||
    normalizedMessage.includes('invalid ethereum address')
  ) {
    return 'Please enter a valid wallet or contract address.';
  }

  if (normalizedMessage.includes('function') && normalizedMessage.includes('not found')) {
    return 'The selected function is not available on the saved contract address.';
  }

  if (normalizedMessage.includes('execution reverted: 0x')) {
    return [
      'The contract rejected this request without giving a reason.',
      'The selected function may not match this contract address.',
    ].join(' ');
  }

  const revertReason = normalizeRevertReason(rawMessage);
  if (revertReason) {
    return `The contract rejected this request: ${revertReason}.`;
  }

  if (normalizedMessage === 'internal json-rpc error.') {
    return [
      'The wallet could not complete this request.',
      'Please check the selected account, network and contract inputs.',
    ].join(' ');
  }

  return rawMessage;
};

export default getContractExecutionErrorMessage;
